(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-intro-products"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('brand-intro-products')) {
  customElements.define('brand-intro-products', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.setupReveal();
      this.motion.addEventListener('change', () => this.setupReveal(), {signal});
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        this.revealAll();
      }, {signal});
    }
    setupReveal() {
      this.observer?.disconnect();
      if (this.motion.matches || this.dataset.effect === 'none' || !('IntersectionObserver' in window)) {
        this.revealAll();
        return;
      }
      const elements = Array.from(this.querySelectorAll('[data-reveal]'));
      elements.forEach(element => element.classList.remove('is-visible'));
      this.setAttribute('data-animated', '');
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          this.observer.unobserve(entry.target);
        });
      }, {threshold: 0.01});
      elements.forEach(element => this.observer.observe(element));
    }
    revealAll() {
      this.observer?.disconnect();
      this.removeAttribute('data-animated');
      this.querySelectorAll('[data-reveal]').forEach(element => element.classList.add('is-visible'));
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-kv"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('brand-intro-products')) {
  customElements.define('brand-intro-products', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.setupReveal();
      this.motion.addEventListener('change', () => this.setupReveal(), {signal});
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        this.revealAll();
      }, {signal});
    }
    setupReveal() {
      this.observer?.disconnect();
      if (this.motion.matches || this.dataset.effect === 'none' || !('IntersectionObserver' in window)) {
        this.revealAll();
        return;
      }
      const elements = Array.from(this.querySelectorAll('[data-reveal]'));
      elements.forEach(element => element.classList.remove('is-visible'));
      this.setAttribute('data-animated', '');
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          this.observer.unobserve(entry.target);
        });
      }, {threshold: 0.01});
      elements.forEach(element => this.observer.observe(element));
    }
    revealAll() {
      this.observer?.disconnect();
      this.removeAttribute('data-animated');
      this.querySelectorAll('[data-reveal]').forEach(element => element.classList.add('is-visible'));
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-products"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('brand-intro-products')) {
  customElements.define('brand-intro-products', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.setupReveal();
      this.motion.addEventListener('change', () => this.setupReveal(), {signal});
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        this.revealAll();
      }, {signal});
    }
    setupReveal() {
      this.observer?.disconnect();
      if (this.motion.matches || this.dataset.effect === 'none' || !('IntersectionObserver' in window)) {
        this.revealAll();
        return;
      }
      const elements = Array.from(this.querySelectorAll('[data-reveal]'));
      elements.forEach(element => element.classList.remove('is-visible'));
      this.setAttribute('data-animated', '');
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          this.observer.unobserve(entry.target);
        });
      }, {threshold: 0.01});
      elements.forEach(element => this.observer.observe(element));
    }
    revealAll() {
      this.observer?.disconnect();
      this.removeAttribute('data-animated');
      this.querySelectorAll('[data-reveal]').forEach(element => element.classList.add('is-visible'));
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('brand-intro-products')) {
  customElements.define('brand-intro-products', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.setupReveal();
      this.motion.addEventListener('change', () => this.setupReveal(), {signal});
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        this.revealAll();
      }, {signal});
    }
    setupReveal() {
      this.observer?.disconnect();
      if (this.motion.matches || this.dataset.effect === 'none' || !('IntersectionObserver' in window)) {
        this.revealAll();
        return;
      }
      const elements = Array.from(this.querySelectorAll('[data-reveal]'));
      elements.forEach(element => element.classList.remove('is-visible'));
      this.setAttribute('data-animated', '');
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          this.observer.unobserve(entry.target);
        });
      }, {threshold: 0.01});
      elements.forEach(element => this.observer.observe(element));
    }
    revealAll() {
      this.observer?.disconnect();
      this.removeAttribute('data-animated');
      this.querySelectorAll('[data-reveal]').forEach(element => element.classList.add('is-visible'));
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["card-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('standalone-card-carousel')) {
    customElements.define('standalone-card-carousel', class extends HTMLElement {
      connectedCallback() {
        this.nav = this.querySelector('.standalone-carousel__nav');
        this.mobile = matchMedia('(max-width: 749px)');
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        if (this.playing === undefined) this.playing = this.dataset.autoplay === 'true' && !this.reducedMotion.matches;
        this.visible = true;
        this.setup();
        this.observer = new MutationObserver(records => {
          if (records.some(record => !this.nav?.contains(record.target))) this.setup();
        });
        this.observer.observe(this, {childList: true, subtree: true});
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.listeners?.abort();
        this.resizeObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.cancelAnimation();
        clearTimeout(this.timer);
        clearTimeout(this.settleTimer);
        cancelAnimationFrame(this.frame);
      }
      setup() {
        const root = this.firstElementChild;
        if (!root) return;
        const children = node => Array.from(node.children).filter(el =>
          !['STYLE', 'SCRIPT', 'TEMPLATE'].includes(el.tagName) && !el.hidden
        );
        const isCard = el => el.matches('.group-block, group-block, .product-card, product-card');
        let target = root;
        const mode = this.dataset.cardTarget || 'auto';
        if (mode !== 'top') {
          // Descend only through a single outer group; do not flatten individual cards.
          let branch = root;
          for (let depth = 0; depth < 5; depth++) {
            const items = children(branch);
            if (items.length >= 2 && (mode === 'nested' || items.every(isCard))) {
              target = branch;
              break;
            }
            if (items.length !== 1) break;
            const only = items[0];
            if (only.matches('.group-block-content')) {
              branch = only;
            } else if (only.matches('.group-block, group-block')) {
              const content = Array.from(only.children).find(el => el.matches('.group-block-content'));
              if (!content) break;
              branch = content;
            } else {
              break;
            }
          }
        }
        this.querySelectorAll('.standalone-carousel__track').forEach(el => {
          if (el !== target) {
            el.classList.remove('standalone-carousel__track');
            el.removeAttribute('tabindex');
            el.removeAttribute('role');
            el.removeAttribute('aria-label');
          }
        });
        target.classList.add('standalone-carousel__track');
        target.setAttribute('role', 'region');
        target.setAttribute('aria-label', '콘텐츠 카드');
        target.setAttribute('tabindex', '0');
        this.querySelectorAll('.standalone-carousel__bridge').forEach(el => el.classList.remove('standalone-carousel__bridge'));
        let ancestor = target.parentElement;
        while (ancestor && ancestor !== this) {
          ancestor.classList.add('standalone-carousel__bridge');
          ancestor = ancestor.parentElement;
        }
        this.bindNavigation(target, children(target));
      }
      bindNavigation(track, cards) {
        if (!this.nav) return;
        this.listeners?.abort();
        this.resizeObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.cancelAnimation();
        this.listeners = new AbortController();
        const signal = this.listeners.signal;
        this.track = track;
        this.cards = cards;
        this.style.setProperty('--cards-pc-visible', String(Math.max(1, Math.min(cards.length || 1, Number(this.dataset.pcVisible) || 3))));
        cards.forEach(card => {
          const image = card.matches('img') ? card : card.querySelector('img');
          if (!image) return;
          image.classList.add('standalone-carousel__image');
          const frame = image.closest('.image-block, .product-card__image, .group-block__media-wrapper, .group-block__media') || (image.parentElement?.tagName === 'PICTURE' ? image.parentElement : null);
          if (frame && frame !== image && frame !== card && card.contains(frame)) frame.classList.add('standalone-carousel__media-frame');
        });
        const pagination = this.nav.querySelector('.standalone-carousel__pagination');
        if (this.count !== cards.length) {
          pagination.replaceChildren();
          cards.forEach((card, index) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'standalone-carousel__segment';
            button.dataset.index = index;
            button.setAttribute('aria-label', `${index + 1}번 카드로 이동`);
            pagination.append(button);
          });
          this.count = cards.length;
        }
        this.nav.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button) return;
          if (button.hasAttribute('data-toggle')) {
            this.playing = !this.playing;
            if (this.playing) { this.focused = false; this.hovered = false; }
            this.updateNavigation();
            this.schedule();
          } else if (button.hasAttribute('data-prev')) this.go(this.index - 1);
          else if (button.hasAttribute('data-next')) this.go(this.index + 1);
          else if (button.dataset.index !== undefined) this.go(Number(button.dataset.index));
        }, {signal});
        track.addEventListener('scroll', () => {
          clearTimeout(this.timer);
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.updateNavigation());
          clearTimeout(this.settleTimer);
          this.settleTimer = setTimeout(() => this.schedule(), 180);
        }, {passive: true, signal});
        track.addEventListener('pointerdown', event => {
          if (!this.mobile.matches || !event.isPrimary || event.button !== 0) return;
          this.cancelAnimation();
          clearTimeout(this.timer);
          if (event.pointerType !== 'mouse' || event.target.closest('button, input, select, textarea')) return;
          this.drag = {id: event.pointerId, x: event.clientX, y: event.clientY, left: track.scrollLeft, index: this.index, moved: false};
        }, {signal});
        track.addEventListener('pointermove', event => {
          const drag = this.drag;
          if (!drag || event.pointerId !== drag.id) return;
          const dx = event.clientX - drag.x;
          if (!drag.moved) {
            if (Math.abs(event.clientY - drag.y) > Math.abs(dx)) { this.drag = null; return; }
            if (Math.abs(dx) < 8) return;
            drag.moved = true;
            track.setPointerCapture(event.pointerId);
            track.setAttribute('data-dragging', '');
          }
          event.preventDefault();
          track.scrollLeft = drag.left - dx;
        }, {signal});
        const endDrag = event => {
          const drag = this.drag;
          if (!drag || drag.id !== event.pointerId) { this.schedule(); return; }
          this.drag = null;
          track.removeAttribute('data-dragging');
          if (drag.moved) {
            if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
            this.suppressClick = true;
            clearTimeout(this.clickTimer);
            this.clickTimer = setTimeout(() => { this.suppressClick = false; }, 100);
            this.updateNavigation();
            this.go(this.index);
          } else this.schedule();
        };
        track.addEventListener('pointerup', endDrag, {signal});
        track.addEventListener('pointercancel', endDrag, {signal});
        track.addEventListener('click', event => {
          if (this.suppressClick) { event.preventDefault(); event.stopImmediatePropagation(); }
        }, {capture: true, signal});
        track.addEventListener('dragstart', event => { if (this.mobile.matches) event.preventDefault(); }, {signal});
        track.addEventListener('keydown', event => {
          if (!this.mobile.matches || event.target !== track) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            const rtl = getComputedStyle(track).direction === 'rtl';
            this.go(this.index + ((event.key === 'ArrowRight') !== rtl ? 1 : -1));
          }
        }, {signal});
        this.addEventListener('focusin', () => { this.focused = true; clearTimeout(this.timer); }, {signal});
        this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); } }, {signal});
        this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; clearTimeout(this.timer); } }, {signal});
        this.addEventListener('pointerleave', event => { if (event.pointerType === 'mouse') { this.hovered = false; this.schedule(); } }, {signal});
        this.addEventListener('load', () => this.updateNavigation(), {capture: true, signal});
        document.addEventListener('visibilitychange', () => this.schedule(), {signal});
        this.mobile.addEventListener('change', () => { this.cancelAnimation(); this.updateNavigation(); this.schedule(); }, {signal});
        this.reducedMotion.addEventListener('change', () => { if (this.reducedMotion.matches) { this.playing = false; this.cancelAnimation(); this.updateNavigation(); this.schedule(); } }, {signal});
        this.resizeObserver = new ResizeObserver(() => { this.updateNavigation(); this.schedule(); });
        this.resizeObserver.observe(track);
        cards.forEach(card => this.resizeObserver.observe(card));
        this.intersectionObserver = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.schedule(); });
        this.intersectionObserver.observe(this);
        this.updateNavigation();
        this.schedule();
      }
      positions() {
        const track = this.track;
        const bounds = track.getBoundingClientRect();
        const max = Math.max(0, track.scrollWidth - track.clientWidth);
        const rtl = getComputedStyle(track).direction === 'rtl';
        return this.cards.map(card => {
          const rect = card.getBoundingClientRect();
          const position = track.scrollLeft + (rtl ? rect.right - bounds.right : rect.left - bounds.left);
          return rtl ? Math.max(-max, Math.min(0, position)) : Math.max(0, Math.min(max, position));
        });
      }
      cancelAnimation() {
        cancelAnimationFrame(this.animation);
        this.animation = null;
        this.track?.removeAttribute('data-animating');
      }
      go(index) {
        const positions = this.positions();
        if (!positions.length) return;
        const next = ((index % positions.length) + positions.length) % positions.length;
        const destination = positions[next];
        clearTimeout(this.timer);
        this.cancelAnimation();
        if (this.reducedMotion.matches) {
          this.track.scrollTo({left: destination, behavior: 'instant'});
          this.updateNavigation();
          this.schedule();
          return;
        }
        const origin = this.track.scrollLeft;
        const distance = destination - origin;
        const start = performance.now();
        const duration = Math.max(200, Math.min(1000, Number(this.dataset.duration) || 450));
        this.track.setAttribute('data-animating', '');
        const animate = now => {
          const progress = Math.min(1, (now - start) / duration);
          const eased = 1 - Math.pow(1 - progress, 3);
          this.track.scrollLeft = origin + distance * eased;
          this.updateNavigation();
          if (progress < 1) this.animation = requestAnimationFrame(animate);
          else {
            this.track.scrollLeft = destination;
            this.track.removeAttribute('data-animating');
            this.animation = null;
            this.updateNavigation();
            this.schedule();
          }
        };
        this.animation = requestAnimationFrame(animate);
      }
      schedule() {
        clearTimeout(this.timer);
        if (!this.isConnected || !this.playing || !this.mobile?.matches || !this.visible || this.focused || this.hovered || this.drag || document.hidden || this.cards?.length < 2 || this.animation) return;
        const delay = Math.max(3, Number(this.dataset.speed) || 4) * 1000;
        this.timer = setTimeout(() => this.go(this.index + 1), delay);
      }
      updateNavigation() {
        if (!this.track || !this.cards?.length) { if (this.nav) this.nav.hidden = true; return; }
        let index = 0, closest = Infinity;
        this.positions().forEach((position, i) => {
          const distance = Math.abs(position - this.track.scrollLeft);
          if (distance < closest) { closest = distance; index = i; }
        });
        this.index = index;
        const overflow = this.track.scrollWidth > this.track.clientWidth + 1;
        this.nav.hidden = this.mobile.matches
          ? this.cards.length < 2 || !overflow
          : this.dataset.showPcNavigation === 'false';
        this.dataset.pcAllVisible = String(!this.mobile.matches && !overflow);
        this.nav.querySelectorAll('[data-index]').forEach((segment, i) => {
          segment.setAttribute('aria-current', i === index ? 'true' : 'false');
          segment.disabled = !this.mobile.matches && !overflow;
          const visibleCount = Math.max(1, Number(this.dataset.pcVisible) || 3);
          segment.dataset.inView = String(!this.mobile.matches && i >= index && i < index + visibleCount);
        });
        const toggle = this.nav.querySelector('[data-toggle]');
        this.nav.dataset.paused = String(!this.playing);
        toggle.setAttribute('aria-label', this.playing ? '자동 넘김 일시정지' : '자동 넘김 재생');
        toggle.setAttribute('aria-pressed', String(!this.playing));
        const status = this.nav.querySelector('[data-status]');
        status.setAttribute('aria-live', this.playing ? 'off' : 'polite');
        const label = `${this.cards.length}개 중 ${index + 1}번째 카드`;
        if (status.textContent !== label) status.textContent = label;
        if (!this.mobile.matches) return;
        const card = this.cards[index];
        const image = card.querySelector('img, .image-block, .group-block__media-wrapper, .group-block__media, .product-card__image');
        const host = this.getBoundingClientRect();
        const bounds = (image || card).getBoundingClientRect();
        if (bounds.height > 0) {
          this.style.setProperty('--cards-arrow-top', `${bounds.top - host.top + (image ? bounds.height / 2 : Math.min(bounds.width, bounds.height) / 2)}px`);
          // Use the image's inset within its own card, independent of horizontal scroll.
          const cardBounds = card.getBoundingClientRect();
          const insetLeft = Math.max(0, bounds.left - cardBounds.left);
          const insetRight = Math.max(0, cardBounds.right - bounds.right);
          this.style.setProperty('--cards-image-left', `${insetLeft}px`);
          this.style.setProperty('--cards-image-right', `${Math.max(0, host.width - cardBounds.width) + insetRight}px`);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["klover-box-products"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('klover-box-product-grid')) {
  customElements.define('klover-box-product-grid', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.nav = this.querySelector('.category-slide__nav');
        this.mobile = matchMedia('(max-width: 749px)');
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        if (this.playing === undefined) this.playing = this.dataset.autoplay === 'true' && !this.reducedMotion.matches;
        this.visible = true;
        this.viewport = this.querySelector('[data-products-viewport]');
        this.pool = this.querySelector('[data-product-pool]');
        this.productCards = Array.from(this.querySelectorAll('[data-product-card]'));
        this.originalCards = this.productCards.slice();
        this.boxOrders = JSON.parse(this.querySelector('[data-box-orders]').textContent);
        this.currentCategory = 'Klover Box 01';
        this.index = 0;
        this.addEventListener('click', event => {
          const button = event.target.closest('.category-products__tab');
          if (button) this.filter(button.dataset.category);
        }, {signal});
        this.mobile.addEventListener('change', () => this.buildPages(), {signal});
        document.addEventListener('shopify:block:select', event => {
          const heading = event.target.closest('[data-heading-category]');
          if (heading && this.contains(heading)) this.filter(heading.dataset.headingCategory, false);
        }, {signal});
        this.filter('Klover Box 01', false);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.listeners?.abort();
        this.resizeObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.cancelAnimation();
        clearTimeout(this.timer);
        clearTimeout(this.settleTimer);
        clearTimeout(this.clickTimer);
        cancelAnimationFrame(this.frame);
      }
      getPageConfig() {
        if (this.mobile.matches) {
          const count = Math.max(1, Math.min(2, Number(this.dataset.columnsMo) || 2));
          return {rows: 1, top: count, bottom: 0, size: count};
        }
        return {rows: 2, top: 2, bottom: 4, size: 6};
      }
      filter(category, announce = true) {
        this.currentCategory = category;
        const order = this.boxOrders[category];
        const rank = new Map((order || []).map((id, index) => [String(id), index]));
        this.productCards = this.originalCards.slice();
        if (order) this.productCards.sort((a, b) => (rank.get(a.dataset.productId) ?? Infinity) - (rank.get(b.dataset.productId) ?? Infinity));
        this.productCards.forEach(card => {
          const categories = (card.dataset.category || '').split(',').map(label => label.trim());
          card.hidden = !categories.includes(category);
        });
        this.querySelectorAll('.category-products__tab').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.category === category)));
        let hasCustomHeading = false;
        this.querySelectorAll('[data-heading-category]').forEach(heading => {
          const match = !hasCustomHeading && heading.dataset.headingCategory === category;
          heading.hidden = !match;
          if (match) hasCustomHeading = true;
        });
        const fallbackHeading = this.querySelector('[data-grid-heading]');
        fallbackHeading.textContent = category;
        fallbackHeading.hidden = hasCustomHeading;
        this.buildPages();
        const count = this.productCards.filter(card => !card.hidden).length;
        this.querySelector('[data-empty]').hidden = count > 0;
        if (announce) this.querySelector('[data-grid-status]').textContent = `${count}개 제품 표시`;
      }
      buildPages() {
        this.cancelAnimation();
        clearTimeout(this.timer);
        const config = this.getPageConfig();
        this.productCards.forEach(card => this.pool.append(card));
        this.viewport.replaceChildren();
        const cards = this.productCards.filter(card => !card.hidden);
        this.pages = [];
        for (let offset = 0; offset < cards.length; offset += config.size) {
          const page = document.createElement('div');
          page.className = 'category-products__page';
          const group = cards.slice(offset, offset + config.size);
          const top = document.createElement('div');
          top.className = 'category-products__row' + (config.rows === 2 ? ' category-products__row--top' : '');
          group.slice(0, config.top).forEach(card => {
            top.append(card);
          });
          page.append(top);
          if (group.length > config.top) {
            const bottom = document.createElement('div');
            bottom.className = 'category-products__row';
            group.slice(config.top).forEach(card => bottom.append(card));
            page.append(bottom);
          }
          this.pages.push(page);
          this.viewport.append(page);
        }
        this.viewport.classList.add('is-paged');
        this.index = 0;
        this.viewport.scrollTo({left: 0, behavior: 'instant'});
        this.bindNavigation(this.viewport, this.pages);
      }
      bindNavigation(track, cards) {
        if (!this.nav) return;
        this.listeners?.abort();
        this.resizeObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.cancelAnimation();
        this.listeners = new AbortController();
        const signal = this.listeners.signal;
        this.track = track;
        this.cards = cards;
        this.style.setProperty('--cards-pc-visible', String(Math.max(1, Math.min(cards.length || 1, Number(this.dataset.pcVisible) || 3))));
        const pagination = this.nav.querySelector('.category-slide__pagination');
        if (true) {
          pagination.replaceChildren();
          cards.forEach((card, index) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'category-slide__segment';
            button.dataset.index = index;
            button.setAttribute('aria-label', `${index + 1}번 카드로 이동`);
            pagination.append(button);
          });
          this.count = cards.length;
        }
        this.nav.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button) return;
          if (button.hasAttribute('data-toggle')) {
            this.playing = !this.playing;
            if (this.playing) { this.focused = false; this.hovered = false; }
            this.updateNavigation();
            this.schedule();
          } else if (button.hasAttribute('data-prev')) this.go(this.index - 1);
          else if (button.hasAttribute('data-next')) this.go(this.index + 1);
          else if (button.dataset.index !== undefined) {
            const positions = this.positions();
            const stops = positions.filter((value, i) => i === 0 || Math.abs(value - positions[i - 1]) > 1);
            this.go(stops.findIndex(value => Math.abs(value - positions[Number(button.dataset.index)]) < 1));
          }
        }, {signal});
        track.addEventListener('scroll', () => {
          clearTimeout(this.timer);
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.updateNavigation());
          clearTimeout(this.settleTimer);
          this.settleTimer = setTimeout(() => this.schedule(), 180);
        }, {passive: true, signal});
        track.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0) return;
          this.cancelAnimation();
          clearTimeout(this.timer);
          if (!this.mobile.matches || event.pointerType !== 'mouse' || event.target.closest('button, input, select, textarea')) return;
          this.drag = {id: event.pointerId, x: event.clientX, y: event.clientY, left: track.scrollLeft, index: this.index, moved: false};
        }, {signal});
        track.addEventListener('pointermove', event => {
          const drag = this.drag;
          if (!drag || event.pointerId !== drag.id) return;
          const dx = event.clientX - drag.x;
          if (!drag.moved) {
            if (Math.abs(event.clientY - drag.y) > Math.abs(dx)) { this.drag = null; return; }
            if (Math.abs(dx) < 8) return;
            drag.moved = true;
            track.setPointerCapture(event.pointerId);
            track.setAttribute('data-dragging', '');
          }
          event.preventDefault();
          track.scrollLeft = drag.left - dx;
        }, {signal});
        const endDrag = event => {
          const drag = this.drag;
          if (!drag || drag.id !== event.pointerId) { this.schedule(); return; }
          this.drag = null;
          track.removeAttribute('data-dragging');
          if (drag.moved) {
            if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
            this.suppressClick = true;
            clearTimeout(this.clickTimer);
            this.clickTimer = setTimeout(() => { this.suppressClick = false; }, 100);
            this.updateNavigation();
            this.go(this.index);
          } else this.schedule();
        };
        track.addEventListener('pointerup', endDrag, {signal});
        track.addEventListener('pointercancel', endDrag, {signal});
        track.addEventListener('click', event => {
          if (this.suppressClick) { event.preventDefault(); event.stopImmediatePropagation(); }
        }, {capture: true, signal});
        track.addEventListener('dragstart', event => { if (this.mobile.matches) event.preventDefault(); }, {signal});
        track.addEventListener('wheel', () => { this.cancelAnimation(); clearTimeout(this.timer); }, {passive: true, signal});
        track.addEventListener('keydown', event => {
          if (!this.mobile.matches || event.target !== track) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            const rtl = getComputedStyle(track).direction === 'rtl';
            this.go(this.index + ((event.key === 'ArrowRight') !== rtl ? 1 : -1));
          }
        }, {signal});
        this.addEventListener('focusin', () => { this.focused = true; clearTimeout(this.timer); }, {signal});
        this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); } }, {signal});
        this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; clearTimeout(this.timer); } }, {signal});
        this.addEventListener('pointerleave', event => { if (event.pointerType === 'mouse') { this.hovered = false; this.schedule(); } }, {signal});
        this.addEventListener('load', () => this.updateNavigation(), {capture: true, signal});
        document.addEventListener('visibilitychange', () => this.schedule(), {signal});
        this.mobile.addEventListener('change', () => { this.cancelAnimation(); this.updateNavigation(); this.schedule(); }, {signal});
        this.reducedMotion.addEventListener('change', () => { if (this.reducedMotion.matches) { this.playing = false; this.cancelAnimation(); this.updateNavigation(); this.schedule(); } }, {signal});
        this.resizeObserver = new ResizeObserver(() => { this.cancelAnimation(); this.updateNavigation(); this.schedule(); });
        this.resizeObserver.observe(track);
        cards.forEach(card => this.resizeObserver.observe(card));
        this.intersectionObserver = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.schedule(); });
        this.intersectionObserver.observe(this);
        this.updateNavigation();
        this.schedule();
      }
      positions() {
        const track = this.track;
        const bounds = track.getBoundingClientRect();
        const max = Math.max(0, track.scrollWidth - track.clientWidth);
        const rtl = getComputedStyle(track).direction === 'rtl';
        return this.cards.map(card => {
          const rect = card.getBoundingClientRect();
          const position = track.scrollLeft + (rtl ? rect.right - bounds.right : rect.left - bounds.left);
          return rtl ? Math.max(-max, Math.min(0, position)) : Math.max(0, Math.min(max, position));
        });
      }
      cancelAnimation() {
        cancelAnimationFrame(this.animation);
        this.animation = null;
        this.track?.removeAttribute('data-animating');
      }
      go(index) {
        const positions = this.positions();
        if (!positions.length) return;
        const stops = positions.filter((value, i) => i === 0 || Math.abs(value - positions[i - 1]) > 1);
        const next = ((index % stops.length) + stops.length) % stops.length;
        const destination = stops[next];
        clearTimeout(this.timer);
        this.cancelAnimation();
        if (this.reducedMotion.matches) {
          this.track.scrollTo({left: destination, behavior: 'instant'});
          this.updateNavigation();
          this.schedule();
          return;
        }
        const origin = this.track.scrollLeft;
        const distance = destination - origin;
        const start = performance.now();
        const duration = Math.max(200, Math.min(1000, Number(this.dataset.duration) || 450));
        this.track.setAttribute('data-animating', '');
        const animate = now => {
          const progress = Math.min(1, (now - start) / duration);
          const eased = 1 - Math.pow(1 - progress, 3);
          this.track.scrollLeft = origin + distance * eased;
          this.updateNavigation();
          if (progress < 1) this.animation = requestAnimationFrame(animate);
          else {
            this.track.scrollLeft = destination;
            this.track.removeAttribute('data-animating');
            this.animation = null;
            this.updateNavigation();
            this.schedule();
          }
        };
        this.animation = requestAnimationFrame(animate);
      }
      schedule() {
        clearTimeout(this.timer);
        if (!this.isConnected || !this.playing || !this.mobile?.matches || !this.visible || this.focused || this.hovered || this.drag || document.hidden || this.cards?.length < 2 || this.animation) return;
        const delay = Math.max(3, Number(this.dataset.speed) || 4) * 1000;
        this.timer = setTimeout(() => this.go(this.index + 1), delay);
      }
      updateNavigation() {
        if (!this.track || !this.cards?.length) { if (this.nav) this.nav.hidden = true; return; }
        let index = 0, closest = Infinity;
        const allPositions = this.positions();
        const stops = allPositions.filter((value, i) => i === 0 || Math.abs(value - allPositions[i - 1]) > 1);
        stops.forEach((position, i) => {
          const distance = Math.abs(position - this.track.scrollLeft);
          if (distance < closest) { closest = distance; index = i; }
        });
        this.index = index;
        const overflow = this.track.scrollWidth > this.track.clientWidth + 1;
        this.nav.hidden = this.mobile.matches
          ? this.cards.length < 2 || !overflow
          : this.dataset.showPcNavigation === 'false' || !this.cards.length;
        this.dataset.pcAllVisible = String(!this.mobile.matches && !overflow);
        this.nav.querySelectorAll('[data-index]').forEach((segment, i) => {
          const active = Math.abs(allPositions[i] - stops[index]) < 1;
          segment.setAttribute('aria-current', active ? 'true' : 'false');
          segment.disabled = !this.mobile.matches && !overflow;
          const visibleCount = Math.max(1, Number(this.dataset.pcVisible) || 3);
          const bounds = this.track.getBoundingClientRect();
          const rect = this.cards[i].getBoundingClientRect();
          segment.dataset.inView = String(!this.mobile.matches && rect.left >= bounds.left - 1 && rect.right <= bounds.right + 1);
        });
        const toggle = this.nav.querySelector('[data-toggle]');
        this.nav.dataset.paused = String(!this.playing);
        toggle.setAttribute('aria-label', this.playing ? '자동 넘김 일시정지' : '자동 넘김 재생');
        toggle.setAttribute('aria-pressed', String(!this.playing));
        const status = this.nav.querySelector('[data-status]');
        status.setAttribute('aria-live', this.playing ? 'off' : 'polite');
        const label = `${this.cards.length}개 중 ${index + 1}번째 카드`;
        if (status.textContent !== label) status.textContent = label;
        if (!this.mobile.matches) return;
        const card = this.cards[index];
        const image = card.querySelector('.category-products__row');
        const host = this.getBoundingClientRect();
        const bounds = (image || card).getBoundingClientRect();
        if (bounds.height > 0) {
          this.style.setProperty('--cards-arrow-top', `${bounds.top - host.top + (image ? bounds.height / 2 : Math.min(bounds.width, bounds.height) / 2)}px`);
          // Use the image's inset within its own card, independent of horizontal scroll.
          const cardBounds = card.getBoundingClientRect();
          const insetLeft = Math.max(0, bounds.left - cardBounds.left);
          const insetRight = Math.max(0, cardBounds.right - bounds.right);
          this.style.setProperty('--cards-image-left', `${this.track.getBoundingClientRect().left - host.left + insetLeft}px`);
          this.style.setProperty('--cards-image-right', `${Math.max(0, host.right - this.track.getBoundingClientRect().left - cardBounds.width) + insetRight}px`);
        }
      }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["klover-brands-page"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('klover-brands-page')) {
  customElements.define('klover-brands-page', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.cards = Array.from(this.querySelectorAll('[data-brand-card]'));
      this.input = this.querySelector('[data-search-input]');
      this.onlyFavorites = false;
      this.favorites = this.readFavorites();
      this.filterButton = this.querySelector('[data-favorites-filter]');
      if (this.filterButton) this.filterButton.hidden = false;
      this.querySelectorAll('[data-favorite-toggle]').forEach(button => { button.hidden = false; });
      this.input?.addEventListener('input', () => this.update(), {signal});
      this.querySelector('[data-brand-search]')?.addEventListener('submit', event => { event.preventDefault(); this.update(); }, {signal});
      this.addEventListener('click', event => {
        const favorite = event.target.closest('[data-favorite-toggle]');
        if (favorite && this.contains(favorite)) {
          const key = favorite.closest('[data-brand-card]').dataset.brandKey;
          if (this.favorites.has(key)) this.favorites.delete(key);
          else this.favorites.add(key);
          try { localStorage.setItem(this.dataset.storageKey, JSON.stringify(Array.from(this.favorites))); } catch (_) {}
          document.dispatchEvent(new CustomEvent('klover:brand-favorites', {detail: {key: this.dataset.storageKey, values: Array.from(this.favorites)}}));
          this.update();
          return;
        }
        if (event.target.closest('[data-favorites-filter]')) {
          this.onlyFavorites = !this.onlyFavorites;
          this.update();
        }
      }, {signal});
      document.addEventListener('klover:brand-favorites', event => {
        if (event.detail.key !== this.dataset.storageKey) return;
        this.favorites = new Set(event.detail.values);
        this.update();
      }, {signal});
      window.addEventListener('storage', event => {
        if (event.key === this.dataset.storageKey || event.key === null) {
          this.favorites = this.readFavorites(); this.update();
        }
      }, {signal});
      document.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('[data-brand-card]');
        if (!card || !this.contains(card)) return;
        if (this.input) this.input.value = '';
        this.onlyFavorites = false;
        this.update();
      }, {signal});
      this.update();
    }
    disconnectedCallback() { this.controller?.abort(); }
    readFavorites() {
      try {
        const values = JSON.parse(localStorage.getItem(this.dataset.storageKey) || '[]');
        return new Set(Array.isArray(values) ? values.filter(value => typeof value === 'string') : []);
      } catch (_) { return new Set(); }
    }
    normalize(value) { return String(value || '').normalize('NFKC').toLocaleLowerCase().replace(/\s+/g, ' ').trim(); }
    update() {
      const query = this.normalize(this.input?.value);
      let visible = 0;
      const saved = new Set();
      this.cards.forEach(card => {
        const favorite = this.favorites.has(card.dataset.brandKey);
        if (favorite) saved.add(card.dataset.brandKey);
        const matches = this.normalize(`${card.dataset.brandName} ${card.dataset.keywords}`).includes(query);
        card.hidden = !matches || (this.onlyFavorites && !favorite);
        if (!card.hidden) visible++;
        card.querySelector('[data-favorite-toggle]')?.setAttribute('aria-pressed', String(favorite));
      });
      this.querySelector('[data-favorites-count]')?.replaceChildren(String(saved.size));
      this.filterButton?.setAttribute('aria-pressed', String(this.onlyFavorites));
      this.querySelector('[data-empty-search]').hidden = visible > 0 || this.onlyFavorites;
      this.querySelector('[data-empty-favorites]').hidden = visible > 0 || !this.onlyFavorites;
      const status = this.querySelector('[data-result-status]');
      if (status) status.textContent = `${status.dataset.statusLabel} ${visible}`;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-intro-kv"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('product-intro-kv')) {
  customElements.define('product-intro-kv', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.setupReveal();
      this.motion.addEventListener('change', () => this.setupReveal(), {signal});
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        this.revealAll();
      }, {signal});
    }
    setupReveal() {
      this.observer?.disconnect();
      if (this.motion.matches || this.dataset.effect === 'none' || !('IntersectionObserver' in window)) {
        this.revealAll();
        return;
      }
      const elements = Array.from(this.querySelectorAll('[data-reveal]'));
      elements.forEach(element => element.classList.remove('is-visible'));
      this.setAttribute('data-animated', '');
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          this.observer.unobserve(entry.target);
        });
      }, {threshold: 0.01});
      elements.forEach(element => this.observer.observe(element));
    }
    revealAll() {
      this.observer?.disconnect();
      this.removeAttribute('data-animated');
      this.querySelectorAll('[data-reveal]').forEach(element => element.classList.add('is-visible'));
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recommended-products-carousel"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('recommended-products-carousel')) {
  customElements.define('recommended-products-carousel', class extends HTMLElement {
      connectedCallback() {
        this.nav = this.querySelector('.recommended-slide__nav');
        this.mobile = matchMedia('(max-width: 749px)');
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        if (this.playing === undefined) this.playing = this.dataset.autoplay === 'true' && !this.reducedMotion.matches;
        this.visible = true;
        const track = this.querySelector('[data-recommended-track]');
        this.bindNavigation(track, Array.from(this.querySelectorAll('[data-recommended-card]')));
        document.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('[data-recommended-card]');
          if (!card || !this.contains(card)) return;
          const positions = this.positions();
          const stops = positions.filter((value, i) => i === 0 || Math.abs(value - positions[i - 1]) > 1);
          this.go(stops.findIndex(value => Math.abs(value - positions[this.cards.indexOf(card)]) < 1));
        }, {signal: this.listeners.signal});
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.listeners?.abort();
        this.resizeObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.cancelAnimation();
        clearTimeout(this.timer);
        clearTimeout(this.settleTimer);
        clearTimeout(this.clickTimer);
        cancelAnimationFrame(this.frame);
      }
      bindNavigation(track, cards) {
        if (!this.nav) return;
        this.listeners?.abort();
        this.resizeObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.cancelAnimation();
        this.listeners = new AbortController();
        const signal = this.listeners.signal;
        this.track = track;
        this.cards = cards;
        this.style.setProperty('--cards-pc-visible', String(Math.max(1, Math.min(cards.length || 1, Number(this.dataset.pcVisible) || 3))));
        const pagination = this.nav.querySelector('.recommended-slide__pagination');
        if (true) {
          pagination.replaceChildren();
          cards.forEach((card, index) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'recommended-slide__segment';
            button.dataset.index = index;
            button.setAttribute('aria-label', `${index + 1}번 카드로 이동`);
            pagination.append(button);
          });
          this.count = cards.length;
        }
        this.nav.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button) return;
          if (button.hasAttribute('data-toggle')) {
            this.playing = !this.playing;
            if (this.playing) { this.focused = false; this.hovered = false; }
            this.updateNavigation();
            this.schedule();
          } else if (button.hasAttribute('data-prev')) this.go(this.index - 1);
          else if (button.hasAttribute('data-next')) this.go(this.index + 1);
          else if (button.dataset.index !== undefined) {
            const positions = this.positions();
            const stops = positions.filter((value, i) => i === 0 || Math.abs(value - positions[i - 1]) > 1);
            this.go(stops.findIndex(value => Math.abs(value - positions[Number(button.dataset.index)]) < 1));
          }
        }, {signal});
        track.addEventListener('scroll', () => {
          clearTimeout(this.timer);
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.updateNavigation());
          clearTimeout(this.settleTimer);
          this.settleTimer = setTimeout(() => this.schedule(), 180);
        }, {passive: true, signal});
        track.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0) return;
          this.cancelAnimation();
          clearTimeout(this.timer);
          if (!this.mobile.matches || event.pointerType !== 'mouse' || event.target.closest('button, input, select, textarea')) return;
          this.drag = {id: event.pointerId, x: event.clientX, y: event.clientY, left: track.scrollLeft, index: this.index, moved: false};
        }, {signal});
        track.addEventListener('pointermove', event => {
          const drag = this.drag;
          if (!drag || event.pointerId !== drag.id) return;
          const dx = event.clientX - drag.x;
          if (!drag.moved) {
            if (Math.abs(event.clientY - drag.y) > Math.abs(dx)) { this.drag = null; return; }
            if (Math.abs(dx) < 8) return;
            drag.moved = true;
            track.setPointerCapture(event.pointerId);
            track.setAttribute('data-dragging', '');
          }
          event.preventDefault();
          track.scrollLeft = drag.left - dx;
        }, {signal});
        const endDrag = event => {
          const drag = this.drag;
          if (!drag || drag.id !== event.pointerId) { this.schedule(); return; }
          this.drag = null;
          track.removeAttribute('data-dragging');
          if (drag.moved) {
            if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
            this.suppressClick = true;
            clearTimeout(this.clickTimer);
            this.clickTimer = setTimeout(() => { this.suppressClick = false; }, 100);
            this.updateNavigation();
            this.go(this.index);
          } else this.schedule();
        };
        track.addEventListener('pointerup', endDrag, {signal});
        track.addEventListener('pointercancel', endDrag, {signal});
        track.addEventListener('click', event => {
          if (this.suppressClick) { event.preventDefault(); event.stopImmediatePropagation(); }
        }, {capture: true, signal});
        track.addEventListener('dragstart', event => { if (this.mobile.matches) event.preventDefault(); }, {signal});
        track.addEventListener('wheel', () => { this.cancelAnimation(); clearTimeout(this.timer); }, {passive: true, signal});
        track.addEventListener('keydown', event => {
          if (!this.mobile.matches || event.target !== track) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            const rtl = getComputedStyle(track).direction === 'rtl';
            this.go(this.index + ((event.key === 'ArrowRight') !== rtl ? 1 : -1));
          }
        }, {signal});
        this.addEventListener('focusin', () => { this.focused = true; clearTimeout(this.timer); }, {signal});
        this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); } }, {signal});
        this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; clearTimeout(this.timer); } }, {signal});
        this.addEventListener('pointerleave', event => { if (event.pointerType === 'mouse') { this.hovered = false; this.schedule(); } }, {signal});
        this.addEventListener('load', () => this.updateNavigation(), {capture: true, signal});
        document.addEventListener('visibilitychange', () => this.schedule(), {signal});
        this.mobile.addEventListener('change', () => { this.cancelAnimation(); this.updateNavigation(); this.schedule(); }, {signal});
        this.reducedMotion.addEventListener('change', () => { if (this.reducedMotion.matches) { this.playing = false; this.cancelAnimation(); this.updateNavigation(); this.schedule(); } }, {signal});
        this.resizeObserver = new ResizeObserver(() => { this.cancelAnimation(); this.updateNavigation(); this.schedule(); });
        this.resizeObserver.observe(track);
        cards.forEach(card => this.resizeObserver.observe(card));
        this.intersectionObserver = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.schedule(); });
        this.intersectionObserver.observe(this);
        this.updateNavigation();
        this.schedule();
      }
      positions() {
        const track = this.track;
        const bounds = track.getBoundingClientRect();
        const max = Math.max(0, track.scrollWidth - track.clientWidth);
        const rtl = getComputedStyle(track).direction === 'rtl';
        return this.cards.map(card => {
          const rect = card.getBoundingClientRect();
          const position = track.scrollLeft + (rtl ? rect.right - bounds.right : rect.left - bounds.left);
          return rtl ? Math.max(-max, Math.min(0, position)) : Math.max(0, Math.min(max, position));
        });
      }
      cancelAnimation() {
        cancelAnimationFrame(this.animation);
        this.animation = null;
        this.track?.removeAttribute('data-animating');
      }
      go(index) {
        const positions = this.positions();
        if (!positions.length) return;
        const stops = positions.filter((value, i) => i === 0 || Math.abs(value - positions[i - 1]) > 1);
        const next = ((index % stops.length) + stops.length) % stops.length;
        const destination = stops[next];
        clearTimeout(this.timer);
        this.cancelAnimation();
        if (this.reducedMotion.matches) {
          this.track.scrollTo({left: destination, behavior: 'instant'});
          this.updateNavigation();
          this.schedule();
          return;
        }
        const origin = this.track.scrollLeft;
        const distance = destination - origin;
        const start = performance.now();
        const duration = Math.max(200, Math.min(1000, Number(this.dataset.duration) || 450));
        this.track.setAttribute('data-animating', '');
        const animate = now => {
          const progress = Math.min(1, (now - start) / duration);
          const eased = 1 - Math.pow(1 - progress, 3);
          this.track.scrollLeft = origin + distance * eased;
          this.updateNavigation();
          if (progress < 1) this.animation = requestAnimationFrame(animate);
          else {
            this.track.scrollLeft = destination;
            this.track.removeAttribute('data-animating');
            this.animation = null;
            this.updateNavigation();
            this.schedule();
          }
        };
        this.animation = requestAnimationFrame(animate);
      }
      schedule() {
        clearTimeout(this.timer);
        if (!this.isConnected || !this.playing || !this.mobile?.matches || !this.visible || this.focused || this.hovered || this.drag || document.hidden || this.cards?.length < 2 || this.animation) return;
        const delay = Math.max(3, Number(this.dataset.speed) || 4) * 1000;
        this.timer = setTimeout(() => this.go(this.index + 1), delay);
      }
      updateNavigation() {
        if (!this.track || !this.cards?.length) { if (this.nav) this.nav.hidden = true; return; }
        let index = 0, closest = Infinity;
        const allPositions = this.positions();
        const stops = allPositions.filter((value, i) => i === 0 || Math.abs(value - allPositions[i - 1]) > 1);
        stops.forEach((position, i) => {
          const distance = Math.abs(position - this.track.scrollLeft);
          if (distance < closest) { closest = distance; index = i; }
        });
        this.index = index;
        const overflow = this.track.scrollWidth > this.track.clientWidth + 1;
        this.nav.hidden = this.mobile.matches
          ? this.cards.length < 2 || !overflow
          : this.dataset.showPcNavigation === 'false' || !this.cards.length;
        this.dataset.pcAllVisible = String(!this.mobile.matches && !overflow);
        this.nav.querySelectorAll('[data-index]').forEach((segment, i) => {
          const active = Math.abs(allPositions[i] - stops[index]) < 1;
          segment.setAttribute('aria-current', active ? 'true' : 'false');
          segment.disabled = !this.mobile.matches && !overflow;
          const visibleCount = Math.max(1, Number(this.dataset.pcVisible) || 3);
          const bounds = this.track.getBoundingClientRect();
          const rect = this.cards[i].getBoundingClientRect();
          segment.dataset.inView = String(!this.mobile.matches && rect.left >= bounds.left - 1 && rect.right <= bounds.right + 1);
        });
        const toggle = this.nav.querySelector('[data-toggle]');
        this.nav.dataset.paused = String(!this.playing);
        toggle.setAttribute('aria-label', this.playing ? '자동 넘김 일시정지' : '자동 넘김 재생');
        toggle.setAttribute('aria-pressed', String(!this.playing));
        const status = this.nav.querySelector('[data-status]');
        status.setAttribute('aria-live', this.playing ? 'off' : 'polite');
        const label = `${this.cards.length}개 중 ${index + 1}번째 카드`;
        if (status.textContent !== label) status.textContent = label;
        if (!this.mobile.matches) return;
        const card = this.cards[index];
        const image = card.querySelector('[class$="__image-wrap"]');
        const host = this.getBoundingClientRect();
        const bounds = (image || card).getBoundingClientRect();
        if (bounds.height > 0) {
          this.style.setProperty('--cards-arrow-top', `${bounds.top - host.top + (image ? bounds.height / 2 : Math.min(bounds.width, bounds.height) / 2)}px`);
          // Use the image's inset within its own card, independent of horizontal scroll.
          const cardBounds = card.getBoundingClientRect();
          const insetLeft = Math.max(0, bounds.left - cardBounds.left);
          const insetRight = Math.max(0, cardBounds.right - bounds.right);
          this.style.setProperty('--cards-image-left', `${this.track.getBoundingClientRect().left - host.left + insetLeft}px`);
          this.style.setProperty('--cards-image-right', `${Math.max(0, host.right - this.track.getBoundingClientRect().left - cardBounds.width) + insetRight}px`);
        }
      }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section"] && !Shopify.designMode) return;
  try {
    


if (!customElements.get('klover-video-row-carousel')) {
  customElements.define('klover-video-row-carousel', class extends HTMLElement {
      connectedCallback() {
        // Theme sections may be upgraded before the parser has reached the nav.
        this.readyFrame = requestAnimationFrame(() => this.initialize());
      }
      initialize() {
        if (!this.isConnected || this.initialized) return;
        if (!this.querySelector('.kv-video-slide__nav')) {
          this.readyFrame = requestAnimationFrame(() => this.initialize());
          return;
        }
        this.initialized = true;
        this.root = this.closest('[id^="shopify-section-"]');
        const start = this.root?.querySelector('[data-mobile-slide-start]');
        const end = this.root?.querySelector('[data-mobile-slide-end]');
        if (!start || !end || start.parentNode !== end.parentNode) return;
        this.startMarker = start; this.endMarker = end;
        const videoSelector = 'deferred-media, .video-block, .video-placeholder-wrapper, [data-video-type], video, video-component, video-block, iframe[src*="youtube.com"], iframe[src*="youtube-nocookie.com"], iframe[src*="vimeo.com"], [data-media-type="video"]';
        const isVideoCard = node => node.nodeType === 1 && (node.matches(videoSelector) || node.querySelector(videoSelector));
        const topNodes = [];
        for (let node = start.nextSibling; node && node !== end; node = node.nextSibling) topNodes.push(node);
        let cards = topNodes.filter(isVideoCard);
        // Find a shared video row nested inside a group, preserving captions
        // inside individual cards rather than descending into each media player.
        if (cards.length === 1) {
          let container = cards[0];
          while (container) {
            const children = Array.from(container.children).filter(isVideoCard);
            if (children.length > 1) { cards = children; break; }
            if (children.length !== 1) break;
            container = children[0];
          }
        }
        this.cards = cards;
        this.originalNodes = cards;
        this.anchors = cards.map(card => {
          const anchor = document.createComment('mobile video original position');
          card.before(anchor);
          return anchor;
        });
        this.nav = this.querySelector('.kv-video-slide__nav');
        this.mobile = matchMedia('(max-width: 749px)');
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.playing = this.dataset.autoplay === 'true' && !this.reducedMotion.matches;
        this.visible = true;
        this.frameElement = document.createElement('div');
        this.frameElement.className = 'kv-video-slide';
        this.frameElement.style.cssText = this.getAttribute('style') || '';
        this.frameElement.style.setProperty('--video-card-count', String(Math.max(1, cards.length)));
        this.frameElement.dataset.arrowShape = this.dataset.arrowShape;
        this.frameElement.dataset.indicator = this.dataset.indicator;
        this.track = document.createElement('div');
        this.track.className = 'kv-video-slide__track';
        this.track.tabIndex = 0;
        this.track.setAttribute('role', 'region');
        this.track.setAttribute('aria-label', '모바일 비디오 슬라이드');
        this.frameElement.append(this.track, this.nav);
        (this.anchors[0] || this.endMarker).before(this.frameElement);
        this.applyLayout();
        this.bindNavigation(this.track, this.cards);
        this.track.addEventListener('play', event => {
          if (!this.mobile.matches || this.dataset.enabled === 'false') return;
          const activeCard = this.cards[this.index || 0];
          if (activeCard && !activeCard.contains(event.target) && activeCard !== event.target) event.target.pause?.();
        }, {capture: true, signal: this.listeners.signal});
        this.track.addEventListener('pause', () => this.schedule(), {capture: true, signal: this.listeners.signal});
        this.track.addEventListener('ended', () => this.schedule(), {capture: true, signal: this.listeners.signal});
        this.root.addEventListener('shopify:block:select', event => {
          if (!this.mobile.matches || this.dataset.enabled === 'false') return;
          const card = this.cards.find(card => card === event.target || card.contains(event.target));
          if (!card) return;
          this.playing = false;
          const positions = this.positions();
          const stops = positions.filter((value, i) => i === 0 || Math.abs(value - positions[i - 1]) > 1);
          this.go(stops.findIndex(value => Math.abs(value - positions[this.cards.indexOf(card)]) < 1));
        }, {signal: this.listeners.signal});
      }
      applyLayout() {
        this.lastVideoIndex = undefined;
        const active = this.dataset.enabled !== 'false' && this.cards.length > 0;
        if (active) {
          this.originalNodes.forEach(node => { if (node.parentNode !== this.track) this.track.append(node); });
          this.cards.forEach(card => card.classList.add('kv-video-slide__card'));
          this.frameElement.hidden = false;
        } else {
          this.originalNodes.forEach((node, index) => this.anchors[index].after(node));
          this.cards.forEach(card => card.classList.remove('kv-video-slide__card'));
          this.frameElement.hidden = true;
          this.nav.hidden = true;
          this.track.scrollLeft = 0;
        }
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.readyFrame);
        this.initialized = false;
        this.originalNodes?.forEach((node, index) => { if (this.anchors[index]?.isConnected) this.anchors[index].after(node); });
        this.anchors?.forEach(anchor => anchor.remove());
        this.cards?.forEach(card => card.classList.remove('kv-video-slide__card'));
        if (this.nav) this.append(this.nav);
        this.frameElement?.remove();
        this.controller?.abort();
        this.listeners?.abort();
        this.resizeObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.cancelAnimation();
        clearTimeout(this.timer);
        clearTimeout(this.settleTimer);
        clearTimeout(this.clickTimer);
        cancelAnimationFrame(this.frame);
      }
      bindNavigation(track, cards) {
        if (!this.nav) return;
        this.listeners?.abort();
        this.resizeObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.cancelAnimation();
        this.listeners = new AbortController();
        const signal = this.listeners.signal;
        this.track = track;
        this.cards = cards;
        this.frameElement.style.setProperty('--cards-pc-visible', String(Math.max(1, Math.min(cards.length || 1, Number(this.dataset.pcVisible) || 3))));
        const pagination = this.nav.querySelector('.kv-video-slide__pagination');
        if (true) {
          pagination.replaceChildren();
          cards.forEach((card, index) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'kv-video-slide__segment';
            button.dataset.index = index;
            button.setAttribute('aria-label', `${index + 1}번 카드로 이동`);
            pagination.append(button);
          });
          this.count = cards.length;
        }
        this.nav.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button) return;
          if (button.hasAttribute('data-toggle')) {
            this.playing = !this.playing;
            if (this.playing) { this.focused = false; this.hovered = false; }
            this.updateNavigation();
            this.schedule();
          } else if (button.hasAttribute('data-prev')) this.go(this.index - 1);
          else if (button.hasAttribute('data-next')) this.go(this.index + 1);
          else if (button.dataset.index !== undefined) {
            const positions = this.positions();
            const stops = positions.filter((value, i) => i === 0 || Math.abs(value - positions[i - 1]) > 1);
            this.go(stops.findIndex(value => Math.abs(value - positions[Number(button.dataset.index)]) < 1));
          }
        }, {signal});
        track.addEventListener('scroll', () => {
          clearTimeout(this.timer);
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.updateNavigation());
          clearTimeout(this.settleTimer);
          this.settleTimer = setTimeout(() => this.schedule(), 180);
        }, {passive: true, signal});
        track.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0) return;
          this.cancelAnimation();
          clearTimeout(this.timer);
          this.touching = true;
          if (!this.mobile.matches || event.pointerType !== 'mouse' || event.target.closest('button, input, select, textarea, video, iframe')) return;
          this.drag = {id: event.pointerId, x: event.clientX, y: event.clientY, left: track.scrollLeft, index: this.index, moved: false};
        }, {signal});
        track.addEventListener('pointermove', event => {
          const drag = this.drag;
          if (!drag || event.pointerId !== drag.id) return;
          const dx = event.clientX - drag.x;
          if (!drag.moved) {
            if (Math.abs(event.clientY - drag.y) > Math.abs(dx)) { this.drag = null; return; }
            if (Math.abs(dx) < 8) return;
            drag.moved = true;
            track.setPointerCapture(event.pointerId);
            track.setAttribute('data-dragging', '');
          }
          event.preventDefault();
          track.scrollLeft = drag.left - dx;
        }, {signal});
        const endDrag = event => {
          this.touching = false;
          const drag = this.drag;
          if (!drag || drag.id !== event.pointerId) { this.schedule(); return; }
          this.drag = null;
          track.removeAttribute('data-dragging');
          if (drag.moved) {
            if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
            this.suppressClick = true;
            clearTimeout(this.clickTimer);
            this.clickTimer = setTimeout(() => { this.suppressClick = false; }, 100);
            this.updateNavigation();
            this.go(this.index);
          } else this.schedule();
        };
        track.addEventListener('pointerup', endDrag, {signal});
        track.addEventListener('pointercancel', endDrag, {signal});
        track.addEventListener('click', event => {
          if (this.suppressClick) { event.preventDefault(); event.stopImmediatePropagation(); }
        }, {capture: true, signal});
        track.addEventListener('dragstart', event => { if (this.mobile.matches) event.preventDefault(); }, {signal});
        track.addEventListener('wheel', () => { this.cancelAnimation(); clearTimeout(this.timer); }, {passive: true, signal});
        track.addEventListener('keydown', event => {
          if (!this.mobile.matches || event.target !== track) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            const rtl = getComputedStyle(track).direction === 'rtl';
            this.go(this.index + ((event.key === 'ArrowRight') !== rtl ? 1 : -1));
          }
        }, {signal});
        this.frameElement.addEventListener('focusin', () => { this.focused = true; clearTimeout(this.timer); }, {signal});
        this.frameElement.addEventListener('focusout', event => { if (!this.frameElement.contains(event.relatedTarget)) { this.focused = false; this.schedule(); } }, {signal});
        this.frameElement.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; clearTimeout(this.timer); } }, {signal});
        this.frameElement.addEventListener('pointerleave', event => { if (event.pointerType === 'mouse') { this.hovered = false; this.schedule(); } }, {signal});
        this.frameElement.addEventListener('load', () => this.updateNavigation(), {capture: true, signal});
        this.frameElement.addEventListener('loadedmetadata', () => this.updateNavigation(), {capture: true, signal});
        document.addEventListener('visibilitychange', () => this.schedule(), {signal});
        this.mobile.addEventListener('change', () => { this.cancelAnimation(); this.applyLayout(); this.updateNavigation(); this.schedule(); }, {signal});
        this.reducedMotion.addEventListener('change', () => { if (this.reducedMotion.matches) { this.playing = false; this.cancelAnimation(); this.updateNavigation(); this.schedule(); } }, {signal});
        this.resizeObserver = new ResizeObserver(() => { this.cancelAnimation(); this.updateNavigation(); this.schedule(); });
        this.resizeObserver.observe(track);
        cards.forEach(card => this.resizeObserver.observe(card));
        this.intersectionObserver = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.schedule(); });
        this.intersectionObserver.observe(track);
        this.updateNavigation();
        this.schedule();
      }
      positions() {
        const track = this.track;
        const bounds = track.getBoundingClientRect();
        const max = Math.max(0, track.scrollWidth - track.clientWidth);
        const rtl = getComputedStyle(track).direction === 'rtl';
        return this.cards.map(card => {
          const rect = card.getBoundingClientRect();
          const position = track.scrollLeft + (rtl ? rect.right - bounds.right : rect.left - bounds.left);
          return rtl ? Math.max(-max, Math.min(0, position)) : Math.max(0, Math.min(max, position));
        });
      }
      cancelAnimation() {
        cancelAnimationFrame(this.animation);
        this.animation = null;
        this.track?.removeAttribute('data-animating');
      }
      go(index) {
        const positions = this.positions();
        if (!positions.length) return;
        const stops = positions.filter((value, i) => i === 0 || Math.abs(value - positions[i - 1]) > 1);
        const next = ((index % stops.length) + stops.length) % stops.length;
        const destination = stops[next];
        clearTimeout(this.timer);
        this.cancelAnimation();
        if (this.reducedMotion.matches) {
          this.track.scrollTo({left: destination, behavior: 'instant'});
          this.updateNavigation();
          this.schedule();
          return;
        }
        const origin = this.track.scrollLeft;
        const distance = destination - origin;
        const start = performance.now();
        const duration = Math.max(200, Math.min(1000, Number(this.dataset.duration) || 450));
        this.track.setAttribute('data-animating', '');
        const animate = now => {
          const progress = Math.min(1, (now - start) / duration);
          const eased = 1 - Math.pow(1 - progress, 3);
          this.track.scrollLeft = origin + distance * eased;
          this.updateNavigation();
          if (progress < 1) this.animation = requestAnimationFrame(animate);
          else {
            this.track.scrollLeft = destination;
            this.track.removeAttribute('data-animating');
            this.animation = null;
            this.updateNavigation();
            this.schedule();
          }
        };
        this.animation = requestAnimationFrame(animate);
      }
      schedule() {
        clearTimeout(this.timer);
        if (!this.isConnected || !this.playing || !this.mobile?.matches || this.dataset.enabled === 'false' || !this.visible || this.focused || this.hovered || this.touching || this.drag || document.hidden || this.cards?.length < 2 || this.animation) return;
        const delay = Math.max(3, Number(this.dataset.speed) || 4) * 1000;
        this.timer = setTimeout(() => this.go(this.index + 1), delay);
      }
      updateNavigation() {
        if (!this.mobile.matches || this.dataset.enabled === 'false') { if (this.nav) this.nav.hidden = true; return; }
        if (!this.track || !this.cards?.length) { if (this.nav) this.nav.hidden = true; return; }
        let index = 0, closest = Infinity;
        const allPositions = this.positions();
        const stops = allPositions.filter((value, i) => i === 0 || Math.abs(value - allPositions[i - 1]) > 1);
        stops.forEach((position, i) => {
          const distance = Math.abs(position - this.track.scrollLeft);
          if (distance < closest) { closest = distance; index = i; }
        });
        this.index = index;
        if (this.lastVideoIndex !== index) {
          this.cards.forEach((card, cardIndex) => {
            if (cardIndex === index) return;
            const videos = card.matches('video') ? [card] : card.querySelectorAll('video');
            videos.forEach(video => video.pause());
            card.querySelectorAll('iframe').forEach(iframe => {
              try {
                const url = new URL(iframe.src);
                if (/^(www\.)?youtube(-nocookie)?\.com$/.test(url.hostname)) iframe.contentWindow?.postMessage(JSON.stringify({event:'command',func:'pauseVideo',args:[]}), url.origin);
                if (/^(player\.)?vimeo\.com$/.test(url.hostname)) iframe.contentWindow?.postMessage({method:'pause'}, url.origin);
              } catch (_) {}
            });
          });
          this.lastVideoIndex = index;
        }
        const overflow = this.track.scrollWidth > this.track.clientWidth + 1;
        this.nav.hidden = this.dataset.enabled === 'false' || !this.mobile.matches || (this.mobile.matches
          ? this.cards.length < 2 || !overflow
          : this.dataset.showPcNavigation === 'false' || !this.cards.length);
        this.dataset.pcAllVisible = String(!this.mobile.matches && !overflow);
        this.nav.querySelectorAll('[data-index]').forEach((segment, i) => {
          const active = Math.abs(allPositions[i] - stops[index]) < 1;
          segment.setAttribute('aria-current', active ? 'true' : 'false');
          segment.disabled = !this.mobile.matches && !overflow;
          const visibleCount = Math.max(1, Number(this.dataset.pcVisible) || 3);
          const bounds = this.track.getBoundingClientRect();
          const rect = this.cards[i].getBoundingClientRect();
          segment.dataset.inView = String(!this.mobile.matches && rect.left >= bounds.left - 1 && rect.right <= bounds.right + 1);
        });
        const toggle = this.nav.querySelector('[data-toggle]');
        this.nav.dataset.paused = String(!this.playing);
        toggle.setAttribute('aria-label', this.playing ? '자동 넘김 일시정지' : '자동 넘김 재생');
        toggle.setAttribute('aria-pressed', String(!this.playing));
        const status = this.nav.querySelector('[data-status]');
        status.setAttribute('aria-live', this.playing ? 'off' : 'polite');
        const label = `${this.cards.length}개 중 ${index + 1}번째 카드`;
        if (status.textContent !== label) status.textContent = label;
        if (!this.mobile.matches) return;
        const card = this.cards[index];
        const image = card.matches('deferred-media, video, video-component, video-block') ? card : card.querySelector('deferred-media, video, video-component, video-block, iframe, .video-placeholder-wrapper');
        const host = this.frameElement.getBoundingClientRect();
        const bounds = (image || card).getBoundingClientRect();
        if (bounds.height > 0) {
          this.frameElement.style.setProperty('--cards-arrow-top', `${bounds.top - host.top + (image ? bounds.height / 2 : Math.min(bounds.width, bounds.height) / 2)}px`);
          // Use the image's inset within its own card, independent of horizontal scroll.
          const cardBounds = card.getBoundingClientRect();
          const insetLeft = Math.max(0, bounds.left - cardBounds.left);
          const insetRight = Math.max(0, cardBounds.right - bounds.right);
          this.frameElement.style.setProperty('--cards-image-left', `${this.track.getBoundingClientRect().left - host.left + insetLeft}px`);
          this.frameElement.style.setProperty('--cards-image-right', `${Math.max(0, host.right - this.track.getBoundingClientRect().left - cardBounds.width) + insetRight}px`);
        }
      }
  });
}


  } catch(e) { console.error(e); }
})();
})();
